/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u2m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two minutes gives roughly 30 seconds per quadrant of the mouth, enough time to clean each tooth surface rather than rushing over them. Most people who don't time it brush for well under a minute, which the American Dental Association considers insufficient.`)
};

const es_timer_u2m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos minutos dan aproximadamente 30 segundos por cuadrante de la boca, tiempo suficiente para limpiar cada superficie dental sin apurarse. La mayoría de las personas que no lo cronometran se cepillan por bastante menos de un minuto, algo que la Asociación Dental Americana considera insuficiente.`)
};

const de_timer_u2m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei Minuten ergeben etwa 30 Sekunden pro Mundquadrant, genug Zeit, um jede Zahnfläche zu reinigen, statt sie zu überfliegen. Die meisten Menschen, die nicht die Zeit stoppen, putzen deutlich unter einer Minute — laut American Dental Association nicht ausreichend.`)
};

const nl_timer_u2m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee minuten geeft ongeveer 30 seconden per kwadrant van de mond, genoeg tijd om elk tandoppervlak schoon te maken in plaats van eroverheen te haasten. De meeste mensen die niet timen, poetsen ruim minder dan een minuut, wat de American Dental Association als onvoldoende beschouwt.`)
};

const fr_timer_u2m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux minutes offrent environ 30 secondes par quadrant de la bouche, assez de temps pour nettoyer chaque surface dentaire sans se précipiter. La plupart des personnes qui ne chronomètrent pas se brossent les dents pendant bien moins d’une minute, ce que l’Association dentaire américaine considère comme insuffisant.`)
};

const it_timer_u2m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due minuti danno circa 30 secondi per quadrante della bocca, tempo sufficiente per pulire ogni superficie dentale invece di passarci sopra in fretta. La maggior parte delle persone che non si cronometra si lava i denti per molto meno di un minuto, un tempo che l'American Dental Association considera insufficiente.`)
};

const pt_br2_timer_u2m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dois minutos dão aproximadamente 30 segundos por quadrante da boca, tempo suficiente para limpar cada superfície dos dentes em vez de passar correndo por elas. A maioria das pessoas que não cronometra escova por bem menos de um minuto, o que a Associação Odontológica Americana considera insuficiente.`)
};

const pt_timer_u2m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dois minutos dão cerca de 30 segundos por quadrante da boca, tempo suficiente para limpar cada superfície dentária em vez de a apressar. A maioria das pessoas que não cronometra escova durante bem menos de um minuto, o que a Associação Dentária Americana considera insuficiente.`)
};

const ja_timer_u2m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2分あれば口の各区画に約30秒ずつかけられ、急がずに各歯の表面をきれいにできます。時間を計らない多くの人は1分未満しか磨いておらず、これはアメリカ歯科医師会が不十分とみなす長さです。`)
};

const zh_timer_u2m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两分钟大约相当于口腔每个区域30秒，足够仔细清洁每颗牙齿的表面，而不是匆匆带过。大多数不计时的人刷牙时间远不到一分钟，美国牙科协会认为这是不够的。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u2m_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u2m_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u2m_faq3_a", locale)
	if (locale === "en") return en_timer_u2m_faq3_a(inputs)
	if (locale === "es") return es_timer_u2m_faq3_a(inputs)
	if (locale === "de") return de_timer_u2m_faq3_a(inputs)
	if (locale === "nl") return nl_timer_u2m_faq3_a(inputs)
	if (locale === "fr") return fr_timer_u2m_faq3_a(inputs)
	if (locale === "it") return it_timer_u2m_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u2m_faq3_a(inputs)
	if (locale === "pt") return pt_timer_u2m_faq3_a(inputs)
	if (locale === "ja") return ja_timer_u2m_faq3_a(inputs)
	return zh_timer_u2m_faq3_a(inputs)
};